<template>
  <div class="application_form">
    <template v-if="isShowBtn">
      <el-form :model="query" :rules="rules" label-width="88px" label-position="right">
        <el-row>
          <el-col :span="16">
            <el-form-item label="赛事名称" prop="raceName">
              <el-select
                :popper-append-to-body="false"
                style="width:350px"
                v-model="query.raceName"
                placeholder="请选择赛事"
                @change="selectMatch"
              >
                <el-option
                  v-for="(item,index) in matchList"
                  :key="index"
                  :value="item.id"
                  :label="item.name"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-form :model="query" ref="form" :rules="rules" label-width="88px">
        <el-row>
          <el-col :span="8.5">
            <el-form-item label="单位名称">
              <el-input
                disabled
                v-model="query.schoolName"
                style="width:350px"
                placeholder="请输入学校名称"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="组别" prop="groupId">
              <el-select
                :disabled="isUpdate"
                :popper-append-to-body="false"
                style="width:350px"
                @change="selectGroup"
                v-model="query.groupId"
              >
                <el-option
                  v-for="(item,index) in signGroup"
                  :key="index"
                  :value="item.value"
                  :label="item.label"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8.5">
            <!-- prop="leaderName" -->
            <el-form-item label="领队">
              <el-input
                v-model="query.leaderName"
                :disabled="isUpdate"
                style="width:350px"
                placeholder="请输入姓名"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <!-- prop="leaderPhone" -->
            <el-form-item label="联系电话">
              <el-input
                v-model="query.leaderPhone"
                :disabled="isUpdate"
                style="width:350px"
                :maxlength="11"
                placeholder="请输入手机号"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8.5">
            <!-- prop="coachIds" -->
            <el-form-item label="教练员">
              <el-select
                :disabled="isUpdate"
                :popper-append-to-body="false"
                style="width:350px"
                v-model="query.coachIds"
                @change="selectCoach"
                multiple
                placeholder="请选择教练员"
              >
                <el-option
                  v-for="(item,index) in coachList"
                  :key="index"
                  :disabled="item.disabled"
                  :value="item.id"
                  :label="item.name"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="联系电话">
              <el-select
                disabled
                v-model="query.coachPhones"
                style="width:350px"
                multiple
                placeholder="自动匹配"
              >
                <Option
                  v-for="(item,index) in query.coachPhones"
                  :key="index"
                  :value="item"
                ></Option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <!-- prop="workerNames" -->
            <el-form-item label="工作人员">
              <el-input
                style="width:350px"
                :disabled="isUpdate"
                v-model="query.workerNames"
                placeholder="请输入工作人员姓名"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-table style="width:100%;margin-top:40px" border :data="tableData">
        <el-table-column label="序号" align="center" width="60">
          <template slot-scope="{row,$index}">
            <div @click="addTable" style="cursor:pointer" v-if="row.isAdd">+</div>
            <template v-else>{{$index + 1}}</template>
          </template>
        </el-table-column>
        <el-table-column label="姓名" min-width="130" align="center">
          <template slot-scope="{row,column,$index}">
            <div
              v-if="publishState === 0 || publishState === 2"
              class="table_select_box"
              style="display:flex;align-items:center;justify-content:center;min-height:30px"
              @click.stop="{{changeNum($index,'name',null,null,'editRemarkInput')}}"
            >
              <el-select
                @change="$event=>selectAthlete($event,$index,'name')"
                style="height:30px"
                v-if="editable[$index].name"
                v-model="row.name"
                clearable
                filterable
                size="mini"
                @blur="$event=>handleBlur($event,$index,'name')"
                class="editRemarkInput"
              >
                <el-option
                  :disabled="item.disabled"
                  v-for="item in athleteList"
                  :key="item.id"
                  :value="item.id"
                  :label="item.name"
                ></el-option>
              </el-select>
              <span v-else>{{row.name}}</span>
            </div>
            <span v-else>{{row.name}}</span>
          </template>
        </el-table-column>
        <el-table-column label="性别" min-width="60" align="center" prop="genderText"></el-table-column>
        <el-table-column label="入学时间" min-width="100" align="center" prop="startSchoolDateText"></el-table-column>
        <el-table-column label="学制" min-width="100" align="center" prop="schoolSystemText"></el-table-column>
        <el-table-column label="注册号" min-width="150" align="center" prop="registerNumber"></el-table-column>
        <el-table-column label="竞技操项目" class-name="project" align="center">
          <template v-for="item in aerobicsSportsCount">
            <el-table-column :key="item" :label="'参赛项目' + item" width="130" align="center">
              <template slot-scope="{row,column,$index}">
                <div
                  v-if="publishState === 0 || publishState === 2"
                  class="table_select_box"
                  style="display:flex;align-items:center;justify-content:center;min-height:30px"
                  @click.stop="{{changeNum($index,'aerobicsSports',item,'aerobicsSportsStr','editRemarkInput')}}"
                >
                  <el-select
                    @change="$event=>selectSports($event,$index,'aerobicsSports' + (item - 1),'aerobicsSportsStr')"
                    style="height:30px"
                    v-if="editable[$index]['aerobicsSports' + (item - 1)]"
                    v-model="row['aerobicsSports' + (item - 1)]"
                    clearable
                    filterable
                    size="mini"
                    @blur="$event=>handleBlur($event,$index,'aerobicsSports' + (item - 1))"
                    class="editRemarkInput"
                  >
                    <el-option
                      :disabled="item.disabled"
                      v-for="(item,index) in aerobicsSportsStr"
                      :key="index"
                      :value="item.value"
                      :label="item.value"
                    ></el-option>
                  </el-select>
                  <span v-else>{{row['aerobicsSports' + (item - 1)]}}</span>
                </div>
                <span v-else>{{row['aerobicsSports' + (item - 1)]}}</span>
              </template>
            </el-table-column>
          </template>
        </el-table-column>
        <el-table-column label="全民健身操项目" class-name="project" align="center">
          <template v-for="item in aerobicsPeopleCount">
            <el-table-column :key="item" :label="'参赛项目' + item" width="130" align="center">
              <template slot-scope="{row,column,$index}">
                <div
                  v-if="publishState === 0 || publishState === 2"
                  class="table_select_box"
                  style="display:flex;align-items:center;justify-content:center;min-height:30px"
                  @click.stop="{{changeNum($index,'aerobicsPeople',item,'aerobicsPeopleStr','editRemarkInput')}}"
                >
                  <el-select
                    @change="$event=>selectSports($event,$index,'aerobicsSports' + (item - 1),'aerobicsPeopleStr')"
                    style="height:30px"
                    v-if="editable[$index]['aerobicsPeople' + (item - 1)]"
                    v-model="row['aerobicsPeople' + (item - 1)]"
                    clearable
                    filterable
                    size="mini"
                    @blur="$event=>handleBlur($event,$index,'aerobicsPeople' + (item - 1))"
                    class="editRemarkInput"
                  >
                    <el-option
                      :disabled="item.disabled"
                      v-for="(item,index) in aerobicsPeopleStr"
                      :key="index"
                      :value="item.value"
                      :label="item.value"
                    ></el-option>
                  </el-select>
                  <span v-else>{{row['aerobicsPeople' + (item - 1)]}}</span>
                </div>
                <span v-else>{{row['aerobicsPeople' + (item - 1)]}}</span>
              </template>
            </el-table-column>
          </template>
        </el-table-column>
      </el-table>
      <footer v-if="publishState === 0 || publishState === 2">
        <el-button :loading="loadingData.submitLoading" class="btns" @click="submits('submit')">确认提交</el-button>
        <el-button
          :loading="loadingData.saveLoading"
          class="btns"
          @click="submits('save')"
          style="margin:0 20px;"
        >保存草稿</el-button>
        <el-button class="btns" @click="clearData">清空重置</el-button>
      </footer>
      <footer v-else>
        <span style="font-size:22px">审核状态：</span>
        <span
          :style="{color:publishState === 1?'#1E63B0':'#1CC28C'}"
          style="font-size:18px"
        >{{publishState === 1?'待审核':'审核已通过'}}</span>
      </footer>
    </template>
    <template v-else>
      <div style="padding:160px 0 0 250px">
        <img src="../../assets/img/signUp/no_data.png" alt />
      </div>
    </template>
    <div
      v-if="!hideMask"
      style="width:100%;height:100vh;position:fixed;background:#fff;top:106px;z-index:999999;left:290px;"
    ></div>
  </div>
</template>
<script>
import {
  addSign,
  updateSign,
  getSignDetailBySchool,
  getSignListBySchool
} from "@/api/sign-up-match";
import { getMatchList } from "@/api/sports-management";
import { getCoachList, getAthleteList } from "@/api/athletes.js";
import registerData from "@/assets/json/register.json";
import { table, message } from "@/common/js/mixins";
import { getSession } from "@/utils/storage.js";
import { rule } from "@/utils/utils";
export default {
  mixins: [table, message],
  // 报名表填写
  data() {
    return {
      groupList: [
        {
          name: "甲组",
          value: "甲组"
        },
        {
          name: "乙组",
          value: "乙组"
        },
        {
          name: "丙组",
          value: "丙组"
        },
        {
          name: "丁组",
          value: "丁组"
        }
      ],
      aerobicsSportsStr: [],
      aerobicsPeopleStr: [],
      publishState: 0,
      aerobicsSportsCount: 0,
      aerobicsPeopleCount: 0,
      matchList: [],
      hideMask: false,
      isShowBtn: true,
      coachList: [],
      currentProject: {},
      athleteList: [],
      query: {
        id: "",
        raceName: "",
        matchId: "",
        leaderName: "",
        leaderPhone: "",
        schoolName: JSON.parse(getSession("userInfo")).schoolName,
        groupId: "",
        coachIds: [],
        coachPhones: [],
        coachNames: "",
        workerNames: ""
      },
      titles: [],
      editable: [],
      loadingData: {
        submitLoading: false,
        saveLoading: false
      },
      rules: {
        raceName: [
          {
            required: true,
            message: "赛事名称不能为空",
            trigger: "blur"
          }
        ],
        leaderName: [
          {
            required: true,
            message: "领队姓名不能为空",
            trigger: "change"
          }
        ],
        leaderPhone: [
          { required: true, validator: rule.phone, trigger: "blur" }
        ],
        groupId: [
          {
            required: true,
            message: "组别不能为空",
            trigger: "change"
          }
        ],
        coachIds: [
          {
            required: true,
            message: "教练员不能为空",
            trigger: "change"
          }
        ],
        workerNames: [
          {
            required: true,
            message: "工作人员姓名不能为空",
            trigger: "blur"
          }
        ]
      }
    };
  },
  computed: {
    signGroup() {
      return registerData.registGroup;
    },
    // 状态为0或者2 表示草稿、驳回或未发布，此时可以修改，其他状态禁用
    isUpdate() {
      return this.publishState === 0 || this.publishState === 2 ? false : true;
    }
  },
  methods: {
    // 获取赛事列表
    getMatch() {
      getMatchList({
        project: 3,
        pageNo: 1,
        pageSize: 999
      })
        .then(res => {
          this.matchList = res.list;
          this.isShowBtn = res.list.length === 0 ? false : true;
          this.hideMask = true;
          if (this.$route.query.id) this.selectMatch(this.$route.query.id);
        })
        .catch(err => {
          if (err.data.msg === "当前没有赛事") {
            this.isShowBtn = false;
          }
          this.hideMask = true;
        });
    },
    // 生成表格
    makeTable(count = this.currentProject.count + this.currentProject.alternateCount, pass = false) {
      this.tableData = [];
      this.editable = [];
      this.titles = [];
      for (let i = 0; i < count; i++) {
        let tableObj = {
          name: "选择组别获取运动员",
          genderText: "",
          athleteId: "",
          startSchoolDateText: "",
          schoolSystemText: "",
          registerNumber: "",
          competitiveGymnastics: "",
          nationalFitness: ""
        };
        let titlesObj = [];
        this.aerobicsSportsCount = 0;
        this.aerobicsPeopleCount = 0;
        
        if (!pass) {
          for (let k = 0; k < this.currentProject.aerobicsSportsCount; k++) {
            this.$set(tableObj, ["aerobicsSports" + k], "下拉选择");
            titlesObj.push("aerobicsSports" + k);
          }
          for (let j = 0; j < this.currentProject.aerobicsPeopleCount; j++) {
            this.$set(tableObj, ["aerobicsPeople" + j], "下拉选择");
            titlesObj.push("aerobicsPeople" + j);
          }
          this.aerobicsSportsCount = this.currentProject.aerobicsSportsCount;
          this.aerobicsPeopleCount = this.currentProject.aerobicsPeopleCount;
        } else {
          pass.athleteList.filter(item => {
            const len = item.projectJson.competitiveGymnastics.split(",")
              .length;
            this.aerobicsSportsCount =
              this.aerobicsSportsCount < len ? len : this.aerobicsSportsCount;
            const leng = item.projectJson.nationalFitness.split(",").length;
            this.aerobicsPeopleCount =
              this.aerobicsPeopleCount < leng ? leng : this.aerobicsPeopleCount;
          });
          for (let k = 0; k < this.aerobicsSportsCount; k++) {
            this.$set(tableObj, ["aerobicsSports" + k], "下拉选择");
            titlesObj.push("aerobicsSports" + k);
          }
          for (let j = 0; j < this.aerobicsPeopleCount; j++) {
            this.$set(tableObj, ["aerobicsPeople" + j], "下拉选择");
            titlesObj.push("aerobicsPeople" + j);
          }
        }
        if (this.titles.length == 0) {
          this.titles.push("name", ...titlesObj);
        }
        this.tableData.push({ ...tableObj });
        let obj = {};
        this.titles.filter(temp => {
          obj[temp] = false;
        });
        this.editable.push(obj);
      }
    },
    // 选择赛事
    selectMatch(value) {
      Object.assign(this.query, this.$options.data().query);
      //   this.athleteList = [];
      this.$refs.form.resetFields();
      let data = {};
      this.matchList.filter(item => {
        if (item.id === value) data = item;
      });
      this.currentProject = data;
      this.aerobicsSportsStr = [];
      this.aerobicsPeopleStr = [];
      const aerobicsSportsStr = data.aerobicsSportsStr.split(",");
      const aerobicsPeopleStr = data.aerobicsPeopleStr.split(",");
      aerobicsSportsStr.filter(item => {
        this.aerobicsSportsStr.push({ value: item, disabled: false });
      });
      aerobicsPeopleStr.filter(item => {
        this.aerobicsPeopleStr.push({ value: item, disabled: false });
      });
      Object.assign(this.query, {
        matchId: data.id,
        raceName: value
      });
      this.getSignDetail(value);
    },
    // 保存/提交
    submits(type) {
      this.$refs.form.validate(valid => {
        if (valid) {
          let data = this.formatData();
          if (!data) return;

          if (!this.query.id) {
            this.loadingData.submitLoading = true;
            addSign({
              ...this.query,
              ...data,
              state: type === "submit" ? 1 : 0
            })
              .then(res => {
                this.loadingData.submitLoading = false;

                this.openSuccess(
                  type === "submit" ? "恭喜你，报名成功！" : "保存成功！"
                );

                this.$router.push({
                  path: "/aerobics/aerobics-registration-form-view",
                  query: {
                    id: this.query.raceName
                  }
                });
              })
              .catch(err => {
                this.loadingData.submitLoading = false;
              });
          } else {
            if (type === "submit") this.loadingData.submitLoading = true;
            else this.loadingData.saveLoading = true;
            updateSign({
              ...this.query,
              ...data,
              state: type === "submit" ? 1 : 0
            })
              .then(res => {
                if (type === "submit") this.loadingData.submitLoading = false;
                else this.loadingData.saveLoading = false;

                this.openSuccess(
                  type === "submit" ? "恭喜你，报名成功！" : "保存成功！"
                );

                this.$router.push({
                  path: "/aerobics/aerobics-registration-form-view",
                  query: {
                    id: this.query.raceName
                  }
                });
              })
              .catch(err => {
                if (type === "submit") this.loadingData.submitLoading = false;
                else this.loadingData.saveLoading = false;
              });
          }
        }
      });
    },
    // 清空重置
    clearData() {
      Object.assign(this.query, {
        leaderName: "",
        leaderPhone: "",
        groupId: "",
        coachIds: [],
        coachNames: "",
        coachPhones: [],
        workerNames: ""
      });
      this.tableData.filter((item, index) => {
        for (let temp in item) {
          if (temp === "name") {
            this.$set(this.tableData[index], temp, "下拉/模糊查找");
          } else if (
            temp.indexOf("aerobicsSports") >= 0 ||
            temp.indexOf("aerobicsPeople") >= 0
          ) {
            this.$set(this.tableData[index], temp, "下拉选择");
          } else {
            this.$set(this.tableData[index], temp, "");
          }
        }
      });
      this.editable.filter((item, index) => {
        for (let temp in item) {
          this.$set(this.editable[index], temp, false);
        }
      });
      this.athleteList = [];
      this.$refs.form.resetFields();
      window.scrollTo(0, 0);
    },
    // 保存参数格式化
    formatData() {
      // 格式化参数
      let { coachIds } = this.query;
      let coachNames = [];
      let athleteJson = [];
      let flag = false;
      let data = "";
      coachIds.filter(item => {
        this.coachList.filter(temp => {
          if (item === temp.id) {
            coachNames.push(temp.name);
          }
        });
      });
      this.tableData.filter(item => {
        let aerobicsSportsCount = 0;
        let aerobicsPeopleCount = 0;
        if (
          item.name !== "下拉/模糊查找" &&
          item.name !== "选择组别获取运动员"
        ) {
          flag = true;
          for (let temp in item) {
            if (
              temp.indexOf("aerobicsSports") >= 0 &&
              item[temp] == "下拉选择"
            ) {
              aerobicsSportsCount++;
            }
            if (
              temp.indexOf("aerobicsPeople") >= 0 &&
              item[temp] == "下拉选择"
            ) {
              aerobicsPeopleCount++;
            }
          }

          // if (aerobicsSportsCount === this.currentProject.aerobicsSportsCount && aerobicsPeopleCount === this.currentProject.aerobicsPeopleCount) {
          //   data = "至少选择一个项目!";
          // }
        }
      });
      //   data = `请选择${
      //     temp.indexOf("aerobicsSports") >= 0
      //       ? "竞技操参赛项目"
      //       : "全民健身操参赛项目"
      //   }后进行操作！`;
      if (!flag) return this.openWarn("请添加运动员后进行操作!");
      if (data) return this.openWarn(data);
      this.tableData.filter((item, index) => {
        if (item.athleteId) {
          let competitiveGymnastics = [];
          let nationalFitness = [];
          for (let temp in item) {
            if (
              temp.indexOf("aerobicsSports") >= 0 &&
              item[temp] !== "下拉选择"
            ) {
              !competitiveGymnastics.includes(item[temp])
                ? competitiveGymnastics.push(item[temp])
                : "";
            }
            if (
              temp.indexOf("aerobicsPeople") >= 0 &&
              item[temp] !== "下拉选择"
            ) {
              !nationalFitness.includes(item[temp])
                ? nationalFitness.push(item[temp])
                : "";
            }
          }
          athleteJson.push({
            athleteId: item.athleteId,
            projectJson: {
              competitiveGymnastics: competitiveGymnastics.join(","),
              nationalFitness: nationalFitness.join(",")
            }
          });
        }
      });
      return {
        ...this.query,
        coachIds: coachIds.join(","),
        coachNames: coachNames.join(","),
        coachPhones: this.query.coachPhones.join(","),
        athleteJson: JSON.stringify(athleteJson)
      };
    },
    // 选择运动员
    selectAthlete(value, num, col, details = false) {
      if (value) {
        this.athleteList.filter((item, index) => {
          this.$set(this.athleteList[index], "disabled", false);
        });
        if (!details) this.$set(this.tableData[num], "athleteId", "");
        // 循环表格内，每一行运动员名称与其id与运动员列表中的某一项匹配时，将运动员与表格内的对应的数据进行填充
        this.tableData.filter((item, i) => {
          for (let j = 0; j < this.athleteList.length; j++) {
            if (
              item.name === this.athleteList[j].id ||
              item.athleteId === this.athleteList[j].id
            ) {
              for (let k in this.athleteList[j]) {
                if (item.hasOwnProperty(k) && k !== "remarks") {
                  this.$set(this.tableData[i], k, this.athleteList[j][k]);
                }
                this.$set(
                  this.tableData[i],
                  "athleteId",
                  this.athleteList[j].id
                );
              }
              this.$set(this.athleteList[j], "disabled", true);
              break;
            }
          }
        });
        if (!details) {
          for (let tem in this.tableData[num]) {
            if (
              tem.indexOf("aerobicsSports") >= 0 ||
              tem.indexOf("aerobicsPeople") >= 0
            ) {
              this.$set(this.tableData[num], [tem], "下拉选择");
            }
          }
        }
      } else {
        this.athleteList.filter((item, index) => {
          if (item.id === this.tableData[num].athleteId) {
            this.$set(this.athleteList[index], "disabled", false);
          }
        });
        for (let item in this.tableData[num]) {
          if (
            item.indexOf("aerobicsSports") >= 0 ||
            item.indexOf("aerobicsPeople") >= 0
          ) {
            this.$set(this.tableData[num], [item], "下拉选择");
          }
        }
        Object.assign(this.tableData[num], {
          athleteId: "",
          name: "下拉/模糊查找",
          genderText: "",
          startSchoolDateText: "",
          schoolSystemText: "",
          registerNumber: ""
        });
      }
      setTimeout(() => {
        this.editable[num][col] = false;
      }, 200);
    },
    // 选择竞技操项目
    selectSports(value, num, col, type, details = false) {
      if (value) {
        this[type].filter((item, index) => {
          this.$set(this[type][index], "disabled", false);
        });
        this[type].filter((item, index) => {
          if (this.tableData[num][col] === this[type][index].value) {
            this.$set(this[type][index], "disabled", true);
          }
        });
      }
      setTimeout(() => {
        this.editable[num][col] = false;
      }, 200);
    },
    // 表格输入框离开焦点
    handleBlur(e, index, col) {
      setTimeout(() => {
        if (col == "name" && this.tableData[index][col] === "") {
          this.$set(this.tableData[index], col, "下拉/模糊查找");
        } else if (this.tableData[index][col] === "") {
          this.$set(this.tableData[index], col, "下拉选择");
        }
        this.editable[index][col] = false;
      }, 200);
    },
    // 表格点击
    changeNum(index, row, num, type, className) {
      this.editable.filter(item => {
        for (let temp in item) item[temp] = false;
      });
      this.editable[index][row == "name" ? row : row + (num - 1)] = true;
      if (row == "name" && this.tableData[index][row] === "下拉/模糊查找") {
        this.$set(this.tableData[index], [row], "");
      }
      if (row !== "name") {
        if (this.tableData[index][row + (num - 1)] === "下拉选择") {
          this.$set(this.tableData[index], [row + (num - 1)], "");
        }
        this[type].filter((item, i) => {
          this.$set(this[type][i], "disabled", false);
        });
        this[type].filter((item, i) => {
          for (let temp in this.tableData[index]) {
            if (this.tableData[index][temp] === this[type][i].value) {
              this.$set(this[type][i], "disabled", true);
            }
          }
        });
      }
      //让input自动获取焦点
      this.$nextTick(() => {
        var editInputList = document.getElementsByClassName(className);
        editInputList[0].children[0].children[0].focus();
      });
    },
    // 选择组别，并获取运动员列表
    selectGroup(value) {
      this.getAthleteLists();
    },
    // 获取教练员列表
    getCoachLists() {
      getCoachList({})
        .then(res => {
          this.coachList = [...res];
          res.filter(item => {
            item.disabled = false;
          });
        })
        .catch(err => {});
    },
    // 选择主教练员后获取对应电话填入
    selectCoach(value) {
      this.query.coachPhones = [];
      if (value) {
        this.coachList.filter(item => {
          if (value.indexOf(item.id) >= 0) {
            this.query.coachPhones.push(item.phone);
          }
        });
        let _field = this.$refs["form"].fields;
        _field.map(i => {
          if (i.prop === "coachIds") {
            //通过prop属性值相同来判断是哪个输入框，比如：要移除prop为'user'
            i.resetField();
            return false;
          }
        });
      }
    },
    // 获取当前赛事运动员列表
    getAthleteLists() {
      getAthleteList({
        pageNo: 1,
        pageSize: 999,
        effective: 1,
        isOld: 0,
        groupId: this.query.groupId,
        isPass: 1,
        gender:
          this.currentProject.gender === -1 ? "" : this.currentProject.gender
      })
        .then(res => {
          if (res.list.length === 0) {
            this.openWarn("暂无运动员数据");
          }
          res.list.filter(item => {
            item.disabled = false;
          });
          this.tableData.filter((item, index) => {
            for (let temp in item) {
              if (temp === "name") {
                this.$set(this.tableData[index], temp, "下拉/模糊查找");
              } else if (
                temp.indexOf("aerobicsSports") >= 0 ||
                temp.indexOf("aerobicsPeople") >= 0
              ) {
                this.$set(this.tableData[index], temp, "下拉选择");
              } else this.$set(this.tableData[index], temp, "");
            }
          });
          this.editable.filter((item, index) => {
            for (let temp in item) {
              this.$set(this.editable[index], temp, false);
            }
          });
          this.athleteList = [...res.list];
        })
        .catch(err => {});
    },
    // 获取当前赛事运动员列表（草稿）
    getAthleteListByDraft() {
      return new Promise((resolve, reject) => {
        getAthleteList({
          pageNo: 1,
          pageSize: 999,
          isPass: 1,
          effective: 1,
          isOld: 0,
          groupId: this.query.groupId,
          gender:
            this.currentProject.gender === -1 ? "" : this.currentProject.gender
        })
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    // 获取详情，如果有数据，则表示已经提交或草稿数据，如果审核已通过，则修改表格显示数量
    getSignDetail(id) {
      getSignDetailBySchool({ matchId: id })
        .then(res => {
          if (res) {
            this.publishState = res.state;
            Object.assign(this.query, {
              workerNames: res.workerNames,
              groupId: res.groupId,
              leaderName: res.leaderName,
              leaderPhone: res.leaderPhone,
              coachIds: !res.coachIds ? [] : res.coachIds.split(","),
              coachPhones: !res.coachPhones ? [] : res.coachPhones.split(","),
              id: res.id
            });
            this.getAthleteListByDraft()
              .then(data => {
                data.list.filter(item => {
                  item.disabled = false;
                });
                this.athleteList = [...data.list];
                if (res.state === 3 || res.state === 1)
                  this.makeTable(res.athleteList.length, res);
                else this.makeTable();
                for (let i = 0; i < this.tableData.length; i++) {
                  this.$set(this.tableData[i], "name", "下拉/模糊查找");
                }
                let competitiveGymnasticsLen = 0;
                let nationalFitnessLen = 0;
                // 获取竞技操项目、健身操项目报名项目的最大值
                res.athleteList.filter((item, index) => {
                  var competitive = !item.projectJson.competitiveGymnastics?0:item.projectJson.competitiveGymnastics.split(
                    ","
                  ).length;
                  competitiveGymnasticsLen =
                    competitiveGymnasticsLen < competitive
                      ? competitive
                      : competitiveGymnasticsLen;
                  var national = !item.projectJson.nationalFitness?0:item.projectJson.nationalFitness.split(",")
                    .length;
                  nationalFitnessLen =
                    nationalFitnessLen < national
                      ? national
                      : nationalFitnessLen;
                });

                res.athleteList.filter((item, index) => {
                  const competitiveGymnastics = !item.projectJson.competitiveGymnastics?[]:item.projectJson.competitiveGymnastics.split(
                    ","
                  );
                  const nationalFitness = !item.projectJson.nationalFitness?[]:item.projectJson.nationalFitness.split(
                    ","
                  );
                  Object.assign(this.tableData[index], {
                    name: item.athleteName,
                    athleteId: item.athleteId
                  });
                  /**
                   * 表格对应项目填充
                   * 注：如果当前赛事为已提交草稿或被驳回等可再次提交状态，则需判断当前赛事的竞技操项目、健美操项目与之前保存的竞技操及健美操项目是否匹配。
                   *    例如：初次保存了3个项目，赛事修改时将项目数量修改，用于此类情况
                   */
                  let aerobicsSports = [];
                  competitiveGymnastics.filter((tem, i) => {
                    const aerobicsSportsStr = this.currentProject.aerobicsSportsStr.split(
                      ","
                    );
                    if (aerobicsSportsStr.includes(tem)) {
                      aerobicsSports.push(tem);
                    }
                  });
                  
                  if (aerobicsSports.length < competitiveGymnasticsLen) {
                    const le = competitiveGymnasticsLen - aerobicsSports.length;
                    let arr = [];
                    for(let i = 0;i < le;i++) {
                      arr.push(res.state === 3?'':"下拉选择");
                    }
                    aerobicsSports.splice(1,0,...arr);
                  }
                  aerobicsSports.filter((tem, i) => {
                    if (this.tableData[index]["aerobicsSports" + i]) {
                      this.$set(
                        this.tableData[index],
                        ["aerobicsSports" + i],
                        tem
                      );
                    }
                  });
                  let aerobicsPeople = [];
                  nationalFitness.filter((tem, i) => {
                    const aerobicsPeopleStr = this.currentProject
                      .aerobicsPeopleStr;
                    if (aerobicsPeopleStr.includes(tem)) {
                      aerobicsPeople.push(tem);
                    }
                  });
                  if (aerobicsPeople.length < nationalFitnessLen) {
                    const le = nationalFitnessLen - aerobicsPeople.length;
                    let arr = [];
                    for(let i = 0;i < le;i++) {
                      arr.push(res.state === 3?'':"下拉选择");
                    }
                    aerobicsPeople.splice(1,0,...arr);
                  }
                  aerobicsPeople.filter((tem, i) => {
                    if (this.tableData[index]["aerobicsPeople" + i]) {
                      this.$set(
                        this.tableData[index],
                        ["aerobicsPeople" + i],
                        tem
                      );
                    }
                  });
                  this.selectAthlete(item.athleteId, index, "name", true);
                });
              })
              .catch(err => {});
          } else {
            this.publishState = 0;
            this.makeTable();
          }
        })
        .catch(err => {});
    }
  },
  mounted() {
    this.getMatch();
    this.getCoachLists();
    window.addEventListener("keydown", e => {
      if (e.keyCode == "9") e.preventDefault();
    });
  },
  destroyed() {
    window.removeEventListener("keydown", event => {
      event.preventDefault();
    });
  }
};
</script>
<style lang="less" scoped>
@import "../../assets/font/pfSembold.css";
@import "../../assets/font/pf.css";
.application_form {
  /deep/ .el-form-item__label {
    font: 500 16px pfSem, PF;
    line-height: 40px;
    // color: #000;
  }
  /deep/ .el-table .cell {
    padding-left: 5px;
    padding-right: 5px;
  }
  /deep/ .el-table thead {
    // color: #444;
    // font-size: 15px;
    th {
      //   background: #eee;
      border-right: 1px solid #ebeef5;
    }
  }
  /deep/ .el-table--border,
  .el-table--group {
    border: 1px solid #ebeef5;
  }
  /deep/ .el-table td,
  /deep/ .el-table th.is-leaf {
    padding: 4px 0;
  }
  /deep/ .el-table td .cell {
    font: 500 13px PF;
    color: #000;
  }
  /deep/ .el-table .project {
    border-bottom: 1px solid #ebeef5;
  }
  .match_list {
    margin: 0 0 20px;
    .match_title {
      font-size: 16px;
      margin-right: 10px;
      font-family: PF;
    }
  }
  .school_name,
  .coach,
  .leader {
    display: flex;
    align-items: center;
    font-size: 18px;
    font-family: pfSem;
    /deep/ .el-input__inner {
      border-left: none;
      border-right: none;
      border-top: none;
      border-radius: 0;
    }
  }
  .leader {
    margin: 10px 0;
  }
  .common_title {
    width: 82px;
    display: flex;
    justify-content: space-between;
  }
  footer {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 60px;
    .btns {
      margin: 0;
      color: #1e63b0;
      border: 1px solid #1e63b0;
    }
  }
}
</style>

    
